import { FC, memo, useEffect } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";

type MapBoundsControllerProps = {
  mapBounds: L.LatLngBoundsLiteral | null;
  mapMaxBounds: L.LatLngBoundsLiteral | null;
  onReady?: (ready: boolean) => void;
};

const MapBoundsController: FC<MapBoundsControllerProps> = memo(
  ({ mapBounds, mapMaxBounds, onReady }) => {
    const map = useMap();

    useEffect(() => {
      if (mapBounds && mapMaxBounds) {
        map.setMaxBounds(mapMaxBounds).fitBounds(mapBounds);
        setTimeout(() => {
          onReady && onReady(true);
        }, 500);
      }
    }, [map, mapBounds, mapMaxBounds, onReady]);

    return null;
  }
);

export { MapBoundsController };
